import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export const incomeStatementAccountValuesSchema = yup.object({
  periodRevenue: yup.string().nullable().optional(),
  major1: yup.string().nullable().optional(),
  revenue1: yup.string().nullable().optional(),
  ytdRevenue: yup.string().nullable().optional(),
  major2: yup.string().nullable().optional(),
  revenue2: yup.string().nullable().optional(),
  changed: yup.string().nullable().optional(),
  periodAverage: yup.string().nullable().optional(),
})

export const incomeStatementAccountRowSchema = yup.object({
  label: yup.string().nullable().optional(),
  values: incomeStatementAccountValuesSchema,
})

export const incomeStatementSinglePeriodXlsxFileDataSchema = yup.object({
  title: yup.string().nullable().optional(),
  description: yup.string().nullable().optional(),
  periodEnd: yup.string().nullable().optional(),
  revenue: yup.array(incomeStatementAccountRowSchema).required(),
  costOfSales: yup.array(incomeStatementAccountRowSchema).required(),
  generalAdministrative: yup.array(incomeStatementAccountRowSchema).required(),
  otherIncome: yup.array(incomeStatementAccountRowSchema).required(),
})

export type IncomeStatementSinglePeriodXlsxFileData = yup.InferType<
  typeof incomeStatementSinglePeriodXlsxFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<IncomeStatementSinglePeriodXlsxFileData>

export const incomeStatementSinglePeriodXlsxFileMappings: RequiredFileData = {
  title: 'b4d73821-1806-4ff8-a8ec-895a0c07fffe',
  description: '3f2cc28c-45f3-4535-819b-0982143b378f',
  periodEnd: '8b6dac17-fed4-4969-aacb-29f654638393',
  revenue: [
    {
      label: 'a0c4bd70-a633-4289-8458-ca081e0bc4ae',
      values: {
        periodRevenue: '65c2d3d5-8cc2-401b-a970-3b75f36faf53',
        major1: '914a311e-b64f-4ffd-9c04-0cc100f0bd84',
        revenue1: 'bc5b7e67-fd77-4592-ac90-3e3717d93fc0',
        ytdRevenue: '9b175265-7ce1-4854-b44f-3efb73bee340',
        major2: 'f28e79b3-eaa0-4f0d-b27e-83a8f3264652',
        revenue2: '38edf42f-ee88-4ec9-9e49-50697823caad',
        changed: '9125cd07-1871-4d4c-a59b-7a5aead844bd',
        periodAverage: '0e0e336e-559f-42a1-8421-1c2e79d33e68',
      },
    },
  ],
  costOfSales: [
    {
      label: '5c441af3-877d-482e-8542-8cdd25faf03a',
      values: {
        periodRevenue: 'a32f00b6-219c-4ec0-a9c6-d508f3076fd7',
        major1: 'cc7e1a03-29fe-4921-a8a9-d698415d1d60',
        revenue1: '6ffe608a-980d-4305-b368-949c91b4abf6',
        ytdRevenue: '031da559-5f81-4f83-9c83-16b58df7a31e',
        major2: '324e606c-fb2b-48b6-bda4-caa298586f9a',
        revenue2: 'ac7ea415-a4a3-45d9-947c-8190476aa7b9',
        changed: '56f2f9fd-77eb-4c17-8e71-0846e5aa508a',
        periodAverage: '4f00b451-c05a-4a81-b6a8-d72c439a1680',
      },
    },
  ],
  generalAdministrative: [
    {
      label: '12e7a875-c258-4a8c-bc59-24135474c169',
      values: {
        periodRevenue: 'de9944a0-7d0b-48b7-bf8c-8e19d2ebfb8c',
        major1: 'd5cb16de-deb2-435e-82db-701116254a8f',
        revenue1: '589733a6-3c46-4531-995b-b0f4f866f9ee',
        ytdRevenue: '83978cd7-f16a-461e-9b2e-47371a1de0a1',
        major2: 'ec8af24c-ce97-4d33-8bd7-b987dc773089',
        revenue2: '7a5fac09-a572-4733-a53c-10e99f1ca8c5',
        changed: 'b92d6b14-c5cc-4bd4-ad1c-eba642b8a310',
        periodAverage: '4bc497cb-e555-4796-84cc-b05bd9e699d1',
      },
    },
  ],
  otherIncome: [
    {
      label: 'a61ef2e0-182d-4739-b0c8-5259230dc2d9',
      values: {
        periodRevenue: '45ae86d2-df47-4000-a9b9-16d516226afc',
        major1: 'c08c30cb-0e18-4a38-8dc5-61808d61e21a',
        revenue1: '2ec79fcd-e8f0-4a70-aad6-70de8725bc1b',
        ytdRevenue: '3cf1d758-5577-4c8f-8fc6-48a7fed3ba23',
        major2: 'a12ec1b4-08af-41bb-8419-3f6b4d6387dd',
        revenue2: 'f37f5cab-653a-4d57-b06e-3a623d01324a',
        changed: '1eaa4da7-a310-4d3d-bec6-11c3f251b8bd',
        periodAverage: 'edecc044-174f-4d87-be45-657cf45d8929',
      },
    },
  ],
}
